import { useLocation } from 'wouter';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

interface HeaderProps {
  title: string;
  backHref?: string;
  rightAction?: React.ReactNode;
  className?: string;
}

export function Header({ title, backHref, rightAction, className }: HeaderProps) {
  const [, navigate] = useLocation();

  return (
    <header
      className={cn('flex items-center justify-between h-14 px-4 pt-safe', className)}
      style={{
        background: 'var(--color-background)',
        borderBottom: '1px solid var(--color-border)',
      }}
    >
      <div className="flex items-center gap-2 min-w-[44px]">
        {backHref && (
          <button
            onClick={() => navigate(backHref)}
            className="touch-target flex items-center justify-center rounded-lg text-[var(--color-text-secondary)] hover:text-[var(--color-text)] transition-colors"
            aria-label="Go back"
          >
            <ArrowLeft size={20} />
          </button>
        )}
      </div>

      <h1
        className="text-base font-semibold text-center flex-1"
        style={{ color: 'var(--color-text)' }}
      >
        {title}
      </h1>

      <div className="flex items-center justify-end min-w-[44px]">
        {rightAction}
      </div>
    </header>
  );
}
